import { WebApi } from "./WebApi";
export class AntiForgery {
    header = "X-XSRF-TOKEN";
    token = "";
    interceptor = 0;
    http = null;
    setup(http) {
        this.http = http;
        this.interceptor = http.interceptors.request.use(config => {
            if (this.token) {
                config.headers[this.header] = this.token;
            }
            return config;
        });
    }
    eject() {
        if (this.http) {
            this.http.interceptors.request.eject(this.interceptor);
        }
    }
    async refresh() {
        if (!this.http) {
            return;
        }
        this.clear();
        let response = await this.http.get("antiforgery");
        this.token = WebApi.responseHandler.handle(response, null);
    }
    clear() {
        this.token = "";
    }
}
